import { combineReducers } from 'redux';
import { formatDate } from '../../core/helpers/default';
import {
  GET_PROSPECTS_REQUEST,
  GET_PROSPECTS_SUCCESS,
  GET_PROSPECTS_FAILED,
} from './actionTypes';
import petitionsReducer from './SelectPetition/reducer';

const initialState = {
  data: [],
  page: 1,
  lastPage: 1,
  loading: false,
  error: null,
  search: '',
  sort: null,
  order: null,
  perPage: 50,
};
const manageProspectsReducer = (state = initialState, {
  type, error, data, meta,
}) => {
  switch (type) {
    case GET_PROSPECTS_REQUEST:
      return { ...state, loading: true };
    case GET_PROSPECTS_SUCCESS:
      return {
        ...state,
        data: data.map((i) => ({
          ...i,
          _selected: false,
          date_requested: i.date_requested ? formatDate(i.date_requested) : '',
          date_generated: i.date_generated ? formatDate(i.date_generated) : '',
        })),
        search: meta.search,
        sort: meta.sort,
        order: meta.order,
        page: meta.current_page,
        lastPage: meta.last_page,
        perPage: meta.per_page,
        loading: false,
      };
    case GET_PROSPECTS_FAILED:
      return { ...state, loading: false, error };
    default:
      return state;
  }
};

export default combineReducers({
  prospects: manageProspectsReducer,
  petitions: petitionsReducer,
});
